import React, { useState, useEffect, useMemo, useRef } from 'react';
import './index.scss';

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const INTERVAL = 1000;

function pad(n) {
  if (n < 10) {
    return `0${n}`;
  }
  return n;
}

function getTimer(endTS, serverTS, start) {
  const end = +new Date(Number(endTS || 0));
  const server = +new Date(Number(serverTS));
  const left0 = end - server - (Date.now() - start);
  if (left0 <= 0 || left0 > DAY * 2) {
    return [true, '', '', '', left0 <= 0];
  }
  const left1 = left0 % DAY;
  const h = pad(Math.max(Math.floor(left1 / HOUR) + Math.floor(left0 / DAY) * 24, 0));
  const left2 = left1 % HOUR;
  const m = pad(Math.max(Math.floor(left2 / MINUTE), 0));
  const left3 = left2 % MINUTE;
  const s = pad(Math.max(Math.floor(left3 / SECOND), 0));

  return [false, h, m, s, false];
}

function FsTimer({ countDown }) {
  const { serverTS, endTS, prefixText } = countDown;
  const [start] = useState(Date.now());
  const [endInit, hInit, mInit, sInit] = useMemo(() => getTimer(endTS, serverTS, start), []);
  const [ended, setEnded] = useState(endInit);
  const divRef = useRef(null);

  useEffect(() => {
    const timerFun = () => {
      setTimeout(() => {
        const [end, h, m, s, isClose] = getTimer(endTS, serverTS, start);
        setEnded(end);

        if (divRef.current) {
          if (end) {
            divRef.current.innerHTML = '';
          } else {
            divRef.current.innerHTML = `<span>${h}</span>:<span>${m}</span>:<span>${s}</span>`;
          }
        }

        !isClose && timerFun();
      }, INTERVAL);
    };

    timerFun();
  }, []);

  return ended ? null : (
    <React.Fragment>
      <span className="hp-countTimeTxt one-line-clamp">{prefixText}</span>
      <span className="hp-countTime" ref={divRef}>
        <span>{hInit}</span>:<span>{mInit}</span>:<span>{sInit}</span>
      </span>
    </React.Fragment>
  );
}
export default FsTimer;
